import queryString from 'query-string'
import {
	CURRENT_WEBSITE_FORM_DATA,
	INVESTMENT_FORM_DATA,
	NEW_WEBSITE_FORM_DATA,
} from './constants'
import { TInvestmentFormValues, TWebsiteFormValues } from './types'

export const convertObjectValuesToNumbers = (
	obj: Record<string, any>,
): Record<keyof typeof obj, number | string> => {
	const result: Record<string, number> = {}

	for (const [key, value] of Object.entries(obj)) {
		const numberValue = Number(value)
		result[key] = Number.isNaN(numberValue) ? value : numberValue
	}
	return result
}

type TgetParsedValuesFromUrlOrDefault = (
	pathname: string,
) => [TWebsiteFormValues, TWebsiteFormValues, TInvestmentFormValues, number]

export const getParsedValuesFromUrlOrDefault: TgetParsedValuesFromUrlOrDefault =
	pathname => {
		if (pathname.startsWith('/avgMRR=')) {
			const [
				querryCurrentWebsiteData,
				querryNewWebsiteData,
				querryInvestmentFormData,
				querryMonthsForChart,
			] = pathname.replace('/', '').split('%7C')

			const parsedCurrentWebsiteData = queryString.parse(
				querryCurrentWebsiteData,
			)
			const parsedNewWebsiteData = queryString.parse(querryNewWebsiteData)
			const parsedInvestmentFormData = queryString.parse(
				querryInvestmentFormData,
			)

			const currentSite = convertObjectValuesToNumbers(
				parsedCurrentWebsiteData,
			) as TWebsiteFormValues
			const newSite = convertObjectValuesToNumbers(
				parsedNewWebsiteData,
			) as TWebsiteFormValues
			const investData = convertObjectValuesToNumbers(
				parsedInvestmentFormData,
			) as TInvestmentFormValues
			const month = Number(querryMonthsForChart)
			return [currentSite, newSite, investData, month]
		}
		return [
			CURRENT_WEBSITE_FORM_DATA,
			NEW_WEBSITE_FORM_DATA,
			INVESTMENT_FORM_DATA,
			12,
		]
	}
